import React from "react";
import { default as MuiPaginationItem } from "@mui/material/PaginationItem";

function PaginationItem(props) {
  return <MuiPaginationItem {...props} />;
}

export default PaginationItem;
